<div class="main-container">
  <img
    style="cursor: pointer"
    width="135"
    src="assets/images/kiosk-deskbird-logo.svg"
    alt="Deskbird Logo"
    class="logo"
  />
  <img
    src="/assets/icons/close.svg"
    class="close-button"
    (click)="navigateToSetup()"
  />
  <span class="title" i18n="@@qr-generator|title">Set up your kiosk</span>
  <div class="qr-container-wrapper">
    <div class="qr-container">
      <qrcode
        [qrdata]="(qrData$ | async)!"
        [allowEmptyString]="true"
        [ariaLabel]="'Scan this QR code to setup the kiosk'"
        [colorDark]="'#000000'"
        [colorLight]="'#ffffff'"
        [elementType]="'canvas'"
        [errorCorrectionLevel]="'M'"
        [cssClass]="'qr-code'"
        [margin]="5"
        [scale]="1"
        [width]="340"
        [title]="'Scan to setup deskbird kiosk'"
        [alt]="'QR code to setup deskbird kiosk'"
        i18n-ariaLabel="@@qr-generator|scanAriaLabel"
        i18n-title="@@qr-generator|scanTitle"
        i18n-alt="@@qr-generator|scanAlt"
      ></qrcode>
    </div>
    <div class="steps-container">
      <div class="step">
        <span class="step-number">1</span>
        <span i18n="@@qr-generator|step1"
          >Make sure you have the deskbird mobile app installed on your phone
          and you are logged in as an admin</span
        >
      </div>
      <div class="step">
        <span class="step-number">2</span>
        <span i18n="@@qr-generator|step2"
          >Use your phone’s camera or a QR code reader to scan the code</span
        >
      </div>
      <div class="step">
        <span class="step-number">3</span>
        <span i18n="@@qr-generator|step3"
          >Fill in the required details to pair your kiosk and submit</span
        >
      </div>
      <div class="step">
        <span class="step-number">4</span>
        <span i18n="@@qr-generator|step4"
          >Your display will automatically launch your meeting room in kiosk
          mode</span
        >
      </div>
    </div>
  </div>
  <div class="countdown-container">
    <span i18n="@@qr-generator|timeout">Session times out in:</span>
    <span class="countdown"> {{ countdown$ | async }}</span>
  </div>
</div>
